import * as React from "react";

const SvgStateIcon = props => <svg width={15} height={16} viewBox="0 0 15 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7.49167 13.8773L1.35 9.06974L0 10.1269L7.5 16L15 10.1269L13.6417 9.06135L7.49167 13.8773ZM7.5 11.7462L13.6333 6.93865L15 5.8731L7.5 0L0 5.8731L1.35833 6.93865L7.5 11.7462ZM7.5 2.12271L12.2833 5.8731L7.5 9.62349L2.71667 5.8731L7.5 2.12271Z" /></svg>;

export default SvgStateIcon;